import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// 导入首页的路由
import homePage from './home-page'
// 导入资金管理模块路由
import fundManagement from './fund-management'
// 导入推广模块路由
import extension from './extension'
// 导入交易模块路由
import transaction from './transaction'
// 导入个人信息路由
import personalInformation from './personal-information'
// 导入消息通知路由
import news from './news'
// 导入下载路由
import download from './download'
// 工单
import ticket from './ticket'
// 导入pamm
import pamm from './pamm'
// 导入pamm
import auth from './auth'
import { getUserInfo } from '@/api/user'
import { fetchUserConfig } from '@/lib/business-api'
import { axios } from '@/utils/axios'
import { ENCRYPTED_FLAG, encryptQuery, decryptQuery } from '@/utils/crypto.js'
let isPermission = false

// vue-route v3.1.0后会出现的报错 参考地址如下
// https://github.com/vuejs/vue-router/issues/2881
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err)
}

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: { name: 'login' }
  },
  {
    // 登录
    path: '/',
    name: 'login',
    component: () => import('@/views/loginregistration/index')
  },
  // 快捷支付绑定
  {
    path: '/quick-pay-bind',
    name: 'quick-pay-bind',
    component: () => import('@/views/loginregistration/index')
  },
  // 快捷支付解绑
  {
    path: '/quick-pay-unbind',
    name: 'quick-pay-unbind',
    component: () => import('@/views/loginregistration/index')
  },
  // 双重登录认证
  {
    path: '/security-auth',
    name: 'security-auth',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 注册真实账号
    path: '/regist-real',
    name: 'regist-real',
    alias: '/register',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 代理申请
    path: '/ib-application',
    name: 'ib-application',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 注册模拟账号
    path: '/regist-simulate',
    name: 'regist-simulate',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 在线客服
    path: '/online-service',
    name: 'online-service',
    component: () => import('@/views/onlineService/index')
  },
  {
    // 忘记密码
    path: '/forget-pwd',
    name: 'forget-pwd',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 注册成功页面
    path: '/regist-success',
    name: 'regist-success',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 注册失败页面
    path: '/regist-fail',
    name: 'regist-fail',
    component: () => import('@/views/loginregistration/index')
  },
  {
    // 邮件链接注册结果检测地址
    path: '/checkRegist',
    name: 'checkRegist',
    component: () => import('@/views/loginregistration/index')
  },
  {
    path: '/invite-code',
    name: 'invite-code',
    component: () => import('@/views/loginregistration/index')
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/policy/policy.vue')
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import('@/views/policy/policy.vue')
  },
  {
    // 主页
    path: '/home',
    name: 'home',
    component: () => import('@/layout/home'),
    children: [
      {
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/personal/guide'),
        meta: {
          isHide: true
        }
      },
      // es6语法 ... 扩展数组 把划分好的路由加入进来
      {
        name: 'empty-page',
        path: '/empty-page',
        component: () => import('@/views/empty-page')
      },
      {
        name: 'external-links',
        path: '/external-links',
        component: () => import('@/views/external-links')
      },
      // 首页路由
      ...homePage,
      // 资金管理路由
      ...fundManagement,
      // 交易模块路由
      ...transaction,
      // 人信息路由
      ...personalInformation,
      // 消息通知路由
      ...news,
      // 下载路由
      ...download,
      // 推广路由
      ...extension,
      // pamm
      ...pamm,
      // 工单
      ...ticket
    ]
  },
  {
    path: '/xmam',
    name: 'Mam',
    component: () => import('@/layout/home.vue'),
    children: [
      {
        path: 'overview',
        name: 'MamOverview',
        component: () => import('@/views/mam/index.vue')
      },
      {
        path: 'signal',
        name: 'MamSignal',
        component: () => import('@/views/mam/index.vue')
      },
      {
        path: 'subscribtion',
        name: 'MamSubscribtion',
        component: () => import('@/views/mam/index.vue')
      }
    ]
  },
  // KYC认证
  ...auth
]

const router = new Router({
  mode: 'history',
  fallback: false,
  routes,
  scrollBehavior(to, from, savedPosition) {
    const main = document.getElementById('crm')
    if (savedPosition) {
      main?.scrollTo(0, 0)
    } else {
      main?.scrollTo(0, 0)
    }
  }
})

// 统一的路由守卫
router.beforeEach(async (to, from, next) => {
  // 1. 登录重定向逻辑
  if (to.path === '/') {
    // 如果当前在登录界面，则获取下用户信息如果能正常获取就进入到首页
    const { code } = await getUserInfo().catch(() => {})
    if (code === 0) {
      next('/index')
      return
    } else {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('publicKey')
    }
  }

  // 2. 权限初始化
  if (!isPermission) {
    await fetchUserConfig(axios, store)
    isPermission = true
  }

  // 3. 处理查询参数加密
  if (to.query && Object.keys(to.query).length > 0 && !to.query[ENCRYPTED_FLAG]) {
    const encryptedQuery = encryptQuery(to.query)
    next({ path: to.path, query: encryptedQuery, replace: false })
    return
  }

  // 4. 处理路由匹配失败的情况
  if (to.matched.length === 0) {
    const arr = to.name?.split(':') || []
    if (arr[1]) {
      next({ name: arr[0], query: { type: arr[1] } })
      return
    }
    from.name ? next({ name: from.name }) : next('/')
    return
  }

  // 5. 权限控制
  if (to.meta.isPermission) {
    // 与后台返回权限进行对比
    if (
      store.state.availableRoutes.some(
        (name) =>
          to.name.toLocaleLowerCase() === name.toLocaleLowerCase() ||
          to.path.toLocaleLowerCase() === '/' + name.toLocaleLowerCase()
      )
    ) {
      next()
    } else {
      // redirect to home page instead of empty page
      // next('/empty-page')
      next('/')
    }
    return
  }

  // 如果不需要特殊处理，直接通过
  next()
})

// 路由解析前处理查询参数解密
router.beforeResolve((to, from, next) => {
  if (to.query && to.query[ENCRYPTED_FLAG]) {
    const decryptedQuery = decryptQuery(to.query)
    Object.assign(to.query, decryptedQuery)
  }
  next()
})

export default router
